import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=0f744bac&scoped=true&"
import script from "./SiteHeader.vue?vue&type=script&lang=js&"
export * from "./SiteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f744bac",
  null
  
)

export default component.exports